<!--企业文化-->
<template>
  <div class="newlist1 flex_column">
    <li @click="newDialog(item)" v-for="(item, index) in data" :key="index">
      <div class="img"><img :src="item.url"></div>
      <div class="right">
        <b>{{item.title}}</b>
        <div class="text">{{item.remark}}</div>
      </div>
    </li>
    <newDialog ref="newDialog" />
  </div>

</template>

<script>
import api from '@/apis/CompanyProfile'
import newDialog from '@/components/newDialog'
export default {
  components: {
    newDialog,
  },
  data() {
    return {
      data: [
        {
          id: 0,
          title: '请添加数据',
          url: require('@/assets/images/pic.png'),
          remark: '请添加数据',
        },
        {
          id: 1,
          title: '请添加数据',
          url: require('@/assets/images/pic.png'),
          remark: '请添加数据',
        },
      ],
      animate: false,
      timer: null,
    }
  },
  methods: {
    newDialog(item) {
      this.$refs.newDialog.dialog({
        title: item.title,
        time: new Date(item.createTime).Format('yyyy-MM-dd'),
        content: item.content,
      })
    },
    scroll() {
      this.animate = true
      document.querySelector('.newlist1  ').style =
        'transition: all 0.2s;margin-top: -' +
        document.querySelector('.newlist1  li').clientHeight +
        'px;'
      setTimeout(() => {
        this.data.push(this.data.shift())
        document.querySelector('.newlist1  ').style = ''
      }, 200)
    },
  },
  mounted() {
    //企业文化
    api.culture({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.data = res.data.list
          if (this.data.length>1) {
            this.timer = setInterval(this.scroll, 3500)
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="less" scoped>
.newlist1 {
  padding: 0px 0.71rem 0.71rem;
  overflow: hidden;
  li {
    height: 4.7rem;
    display: flex;
    flex-direction: row;
    align-items:flex-end;
    width: 100%;
    overflow: hidden;
    margin-top: 0.5rem;
    cursor: pointer;
    .img {
      width: 7.21rem;
      height: 100%;
      margin-right: 0.8rem;
      overflow: hidden;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .right {
      flex: 1;
      height: 100%;
      overflow: hidden;
      b {
        display: block;
        font-weight: 400;
        font-size: 0.8rem;
        color: #05f8fc;
        margin-top: 4px;
        margin-bottom: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .text {
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.65rem;
        height: 3.2rem;
        line-height: 1rem;
      }
    }
    &:hover{
      b{
        text-decoration: underline;
      }
    }
  }
}
</style>